import React from "react";
import { Link } from "react-router-dom";

const style = {
  container: {
    height: "90vh",
    width: "90vw",
    margin: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  btn: {
    backgroundColor: "skyblue",
    padding: "5px",
    fontWeight: "bold",
    border: "1px solid black",
    cursor:'pointer'
    },
   
};
function Error() {
  return (
    <div style={style.container}>
      <div>
        <h1 style={{ color: "black" }}>
          Oop's look like you have followed a broken Url. Click below button to
          go to home page.
        </h1>
        <Link to='/'>
          <button style={style.btn}>Home</button>
        </Link>
      </div>
    </div>
  );
}

export default Error;
